/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Status_Rejected_By_User14Inputs */

const en_application_status_rejected_by_user14 = /** @type {(inputs: Application_Status_Rejected_By_User14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected by user`)
};

const de_application_status_rejected_by_user14 = /** @type {(inputs: Application_Status_Rejected_By_User14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelehnt durch Kandidat:in`)
};

/**
* | output |
* | --- |
* | "Rejected by user" |
*
* @param {Application_Status_Rejected_By_User14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const application_status_rejected_by_user14 = /** @type {((inputs?: Application_Status_Rejected_By_User14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Status_Rejected_By_User14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_status_rejected_by_user14(inputs)
	return en_application_status_rejected_by_user14(inputs)
});
export { application_status_rejected_by_user14 as "application_status_REJECTED_BY_USER" }